import React, { useState } from 'react';
import SensogramIcon from '../../assets/images/products/pie-chart.svg';
import ListIcon from '../../assets/images/products/list.svg';
import ProductSummaryListView from './summary/ProductSummaryListView';
import { emptyProductReportData } from '../../utils/productHelper';
import NoSummaryChart from './summary/NoSummaryChat';

function LoggedoutProductReportMeta({ productId, publicClickAction }) {
    const [showListView, setShowListView] = useState(false),
        productHeaderData = emptyProductReportData.overall;
    return (<div className="product__section product__reports__container">
        <div className="product__reports__left">
            <p className="product__reviews__header">Sensogram</p>
            <p>The following chart depicts the Tasters’ overall product preference and attribute-wise rating on a 7-point scale.</p>
            <ProductSummaryListView
                isPublic={true}
                publicClickAction={publicClickAction}
                headers={productHeaderData}
                productId={productId} />
        </div>
        <div className="product__reports__right">
            <div className="product__reviews__sort">
                <button onClick={() => setShowListView(false)} className={`product__reviews__sort__btn ${showListView ? '' : 'product__reviews__sort__btn--active'}`}>
                    <img src={SensogramIcon} alt="show sensogram"/>
                    SENSOGRAM
                </button>
                <button onClick={() => setShowListView(true)} className={`product__reviews__sort__btn ${!showListView ? '' : 'product__reviews__sort__btn--active'}`}>
                    <img src={ListIcon} alt="show list view" />
                    LIST VIEW
                </button>
            </div>
            {
                showListView
                ? <ProductSummaryListView productId={productId}
                    isPublic={true}
                    publicClickAction={publicClickAction}
                    headers={emptyProductReportData.headers()} />
                : <NoSummaryChart />
            }
        </div>
    </div>)
};

export default LoggedoutProductReportMeta;